import { combineReducers } from 'redux'

import {
  REDUCER_NAMES_FETCH_STATUSES_KEG_COLLECTION_BOOKINGS,
  REDUCER_NAMES_FETCH_STATUSES_KEG_COLLECTION_BOOKINGS_LIST_VIEW_SEARCH_FILTER_OPTIONS,
  REDUCER_NAMES_FETCH_STATUSES_KEG_COLLECTION_BOOKINGS_EXPORT_DATA,
  REDUCER_NAMES_EDIT_KEG_COLLECTION_BOOKING,
  REDUCER_NAMES_FETCH_STATUSES_SINGLE_KEG_COLLECTION_BOOKING,
  REDUCER_NAMES_FETCH_STATUSES_KEG_COLLECTION_BOOKING_COLLECTORS,
  REDUCER_NAMES_FETCH_STATUSES_EDIT_KEG_COLLECTION_REQUEST,
  REDUCER_NAMES_FETCH_STATUSES_KEG_COLLECTION_BOOKING_VENUE_INFO,
  REDUCER_NAMES_FETCH_STATUSES_BOOKINGS_KEG_COLLECTION_CREATE_REQUEST,
  REDUCER_NAMES_FETCH_STATUSES_BOOKINGS_KEG_COLLECTION_DELETE_REQUEST,
  REDUCER_NAMES_FETCH_STATUSES_BOOKINGS_VENUE_COLLECTION_INFO,
} from '../../../../constants'

import fetchBookingsStatusesReducer from './fetchKegCollectionBookings'
import fetchKegCollectionBookingsListViewSearchFilterOptionsStatusesReducer from './bookingsSearchFiltersOptions'
import fetchExportBookingsDataStatusesReducer from './fetchExportBookingsData'
import fetchSingleBookingStatusesReducer from './fetchSingleKegCollectionBooking'
import editBookingDetailsStatusesReducer from './editKegCollectionBooking'
import createKegCollectionStatusesReducer from './createKegCollectionRequest'
import editKegCollectionRequestStatusesReducer from './editKegCollectionRequest'
import deleteKegCollectionStatusesReducer from './deleteKegCollectionRequest'
import fetchCollectorsStatusesReducer from './fetchKegCollectionBookingCollectors'
import fetchKegCollectionBookingVenuesStatusesReducer from './fetchKegCollectionBookingVenues'
import fetchKegCollectionBookingVenueCollectionInfoStatusesReducer from './fetchVenueCollectionInfo'

const kegCollectionBookingsReducers = {
  [REDUCER_NAMES_FETCH_STATUSES_KEG_COLLECTION_BOOKINGS]: fetchBookingsStatusesReducer,
  [REDUCER_NAMES_FETCH_STATUSES_SINGLE_KEG_COLLECTION_BOOKING]: fetchSingleBookingStatusesReducer,
  [REDUCER_NAMES_EDIT_KEG_COLLECTION_BOOKING]: editBookingDetailsStatusesReducer,
  [REDUCER_NAMES_FETCH_STATUSES_KEG_COLLECTION_BOOKING_COLLECTORS]: fetchCollectorsStatusesReducer,
  [REDUCER_NAMES_FETCH_STATUSES_EDIT_KEG_COLLECTION_REQUEST]:
    editKegCollectionRequestStatusesReducer,
  [REDUCER_NAMES_FETCH_STATUSES_KEG_COLLECTION_BOOKING_VENUE_INFO]:
    fetchKegCollectionBookingVenuesStatusesReducer,
  [REDUCER_NAMES_FETCH_STATUSES_BOOKINGS_KEG_COLLECTION_CREATE_REQUEST]:
    createKegCollectionStatusesReducer,
  [REDUCER_NAMES_FETCH_STATUSES_BOOKINGS_KEG_COLLECTION_DELETE_REQUEST]:
    deleteKegCollectionStatusesReducer,
  [REDUCER_NAMES_FETCH_STATUSES_BOOKINGS_VENUE_COLLECTION_INFO]:
    fetchKegCollectionBookingVenueCollectionInfoStatusesReducer,
  [REDUCER_NAMES_FETCH_STATUSES_KEG_COLLECTION_BOOKINGS_EXPORT_DATA]:
    fetchExportBookingsDataStatusesReducer,
  [REDUCER_NAMES_FETCH_STATUSES_KEG_COLLECTION_BOOKINGS_LIST_VIEW_SEARCH_FILTER_OPTIONS]:
    fetchKegCollectionBookingsListViewSearchFilterOptionsStatusesReducer,
}

export default combineReducers(kegCollectionBookingsReducers)
